import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAuthMe,
  fetchTenantBilling,
  setBilling as setAuthBilling,
} from "../../../store/authSlice";
import authAPI from "../../../services/authApi";
import clinicAPI from "../../../services/clinicApi";
import { useToast } from "../../ui";

export function useOwnerProfileForm() {
  const dispatch = useDispatch();
  const toast = useToast();
  const { profile } = useSelector((state) => state.auth);
  const [form, setForm] = useState({ full_name: "", phone: "" });
  const [pwd, setPwd] = useState({ current: "", next: "" });
  const [billing, setBilling] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pwdSaving, setPwdSaving] = useState(false);
  const [payBusy, setPayBusy] = useState(false);

  const loadBilling = useCallback(async () => {
    try {
      const next = await dispatch(fetchTenantBilling()).unwrap();
      setBilling(next || null);
    } catch {
      setBilling(null);
      dispatch(setAuthBilling(null));
    }
  }, [dispatch]);

  useEffect(() => {
    setForm({
      full_name: profile?.full_name || "",
      phone: profile?.phone || "",
    });
  }, [profile]);

  useEffect(() => {
    loadBilling();
  }, [loadBilling]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await authAPI.updateMyAccount({
        full_name: form.full_name,
        phone: form.phone,
      });
      await dispatch(fetchAuthMe());
      toast.success("Сохранено");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  const savePassword = async () => {
    if (!pwd.current || !pwd.next) {
      toast.error("Заполните оба поля пароля");
      return;
    }
    setPwdSaving(true);
    try {
      await authAPI.changePassword(pwd.current, pwd.next);
      setPwd({ current: "", next: "" });
      toast.success("Пароль изменён");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка");
    } finally {
      setPwdSaving(false);
    }
  };

  const paySubscription = async () => {
    setPayBusy(true);
    try {
      const data = await clinicAPI.initTenantSubscriptionPayment();
      if (data.payment_url) {
        window.open(data.payment_url, "_blank", "noopener,noreferrer");
        toast.success("Страница оплаты открыта");
      }
    } catch (e) {
      toast.error(e.response?.data?.error || "Онлайн-оплата недоступна");
    } finally {
      setPayBusy(false);
    }
  };

  return {
    profile,
    form,
    setForm,
    pwd,
    setPwd,
    billing,
    saving,
    pwdSaving,
    payBusy,
    saveProfile,
    savePassword,
    paySubscription,
    loadBilling,
  };
}
